module.exports = __webpack_public_path__ + "media/images/mypage/icon/green/ico_q&a-bd5a29fa75bcf776f2aff6d2a39d219f.svg";